import { render, staticRenderFns } from "./AdditionalCategories.vue?vue&type=template&id=f1942fdc&"
import script from "./AdditionalCategories.vue?vue&type=script&lang=js&"
export * from "./AdditionalCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports